import React, { useState, cloneElement } from 'react';
import Tabs from '../components/hooks/Tabs';
function ProfileLayout({ children, user }) {

    const [tabs, setTabs] = useState([
        { id: 1, name: 'Constancia de situación fiscal', current: true, route: '/situacion-fiscal/constancia' },
        { id: 2, name: 'Opinión de cumplimiento', current: false, route: '/situacion-fiscal/cumplimiento' },
        { id: 3, name: 'Accesos al SAT', current: false, route: '/situacion-fiscal/accesos-sat' },
    ]);

    return (
        <>
            <div className='w-full px-0 py-4 lg:p-6 bg-gray-100 min-h-[calc(100dvh-4rem)] pb-12'>
                <Tabs
                    items={tabs}
                    setItems={setTabs}
                />
                <div className='w-full px-4 lg:px-0'>
                    {cloneElement(children, { user })}
                </div>
            </div>
        </>
    )
}

export default ProfileLayout